import { Button } from '~/components/ui/button';
import { useStore } from '~/store';
import type { LayoutMode } from '~/types/pipeline';

const KINDS: ReadonlyArray<{ kind: LayoutMode['kind']; label: string }> = [
  { kind: 'sequence', label: 'Sequence' },
  { kind: 'free', label: 'Free' },
];

export function LayoutSection() {
  const layoutMode = useStore((s) => s.atlas.layoutMode);
  const setLayoutMode = useStore((s) => s.setLayoutMode);

  const selectKind = (kind: LayoutMode['kind']) => {
    if (kind === 'sequence') {
      setLayoutMode({ kind: 'sequence' });
      return;
    }
    setLayoutMode({ kind: 'free', positions: {} });
  };

  return (
    <section className="space-y-1.5 rounded border p-2">
      <div className="text-[11px] font-medium uppercase tracking-wide text-muted-foreground">
        Layout
      </div>
      <div role="radiogroup" aria-label="Output layout" className="flex gap-0.5">
        {KINDS.map(({ kind, label }) => {
          const selected = layoutMode.kind === kind;
          return (
            <Button
              key={kind}
              type="button"
              size="xs"
              variant={selected ? 'default' : 'outline'}
              role="radio"
              aria-checked={selected}
              onClick={() => selectKind(kind)}
              className="h-7 flex-1"
            >
              {label}
            </Button>
          );
        })}
      </div>
    </section>
  );
}
